import type { AgeGroup } from "../types";

const PORTAL_PREFIX = "/_portal";

export interface ActivateResponse {
  installationId: string;
  credential: string;
  seed: string;
  ageGroup: AgeGroup;
}

export interface SyncProgressPayload {
  doneCount: number;
  skippedCount: number;
  snoozeCount: number;
  score1: number;
  score2: number;
  score3: number;
  activeDays: number;
}

export async function activateInstallation(
  shareToken: string,
  deviceInstallationId: string,
): Promise<ActivateResponse> {
  const res = await fetch(`${PORTAL_PREFIX}/tools/doe-iets-geks/activate`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ shareToken, deviceInstallationId }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error((body as { error?: string }).error ?? `Activatie mislukt (${res.status})`);
  }
  return res.json() as Promise<ActivateResponse>;
}

export async function syncProgress(
  credential: string,
  progress: SyncProgressPayload,
): Promise<SyncProgressPayload> {
  const res = await fetch(`${PORTAL_PREFIX}/tools/doe-iets-geks/sync`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${credential}`,
    },
    body: JSON.stringify(progress),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error((body as { error?: string }).error ?? `Sync mislukt (${res.status})`);
  }
  const data = (await res.json()) as { progress: SyncProgressPayload };
  return data.progress;
}
